/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { BetalerDto as OkEgisServiceModelsDtoBetalerDto } from '../models/OK/Egis/Service/Models/DTO/betaler-dto';

@Injectable({
  providedIn: 'root',
})
export class BetalerService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation getBetalerList
   */
  static readonly GetBetalerListPath = '/api/v1/Betaler/GetBetalerList';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getBetalerList()` instead.
   *
   * This method doesn't expect any request body.
   */
  getBetalerList$Response(params: {

    /**
     * Correlation Id for the request
     */
    correlationId?: string;

    /**
     * The name of the program performing the request
     */
    caller: string;

    /**
     * User Id
     */
    userId?: string;
  }): Observable<StrictHttpResponse<Array<OkEgisServiceModelsDtoBetalerDto>>> {

    const rb = new RequestBuilder(this.rootUrl, BetalerService.GetBetalerListPath, 'get');
    if (params) {
      rb.header('correlationId', params.correlationId, {});
      rb.header('caller', params.caller, {});
      rb.header('userId', params.userId, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<OkEgisServiceModelsDtoBetalerDto>>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getBetalerList$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getBetalerList(params: {

    /**
     * Correlation Id for the request
     */
    correlationId?: string;

    /**
     * The name of the program performing the request
     */
    caller: string;

    /**
     * User Id
     */
    userId?: string;
  }): Observable<Array<OkEgisServiceModelsDtoBetalerDto>> {

    return this.getBetalerList$Response(params).pipe(
      map((r: StrictHttpResponse<Array<OkEgisServiceModelsDtoBetalerDto>>) => r.body as Array<OkEgisServiceModelsDtoBetalerDto>)
    );
  }

}
